export enum GuidelineComponentType {
  Action = 1,
  Criteria = 2,
  Condition = 3,
  Observation = 4,
  ClassificationItem = 5,
}
